import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/curse/bg_notfall.png";
import Img1 from "../../images/curse/notfall_1.jpg";
import Img2 from "../../images/curse/notfall_2.jpg";

const Reanimationstraining = () => {
    return (
        <main>
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1>Kurse – Notfall-Reanimationstraining</h1>

                    <p className="page-text">
                        <b><i>Was tun im Notfall? Wie reagiere ich richtig?</i></b>
                        <br /><br />
                        Wir bieten Ihnen erstmals speziell für Patienten und Angehörige ein Reanimationstraining an.<br />
                        Wir möchten Ihnen die Scheu und Angst nehmen, in kritischen Situationen zuzugreifen.
                    </p>

                    <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap", margin: "20px 0" }}>
                        <img
                            src={Img1}
                            alt="praktische Übungen"
                            title="praktische Übungen"
                            style={{ maxWidth: "280px", height: "auto" }}
                        />
                        <img
                            src={Img2}
                            alt="praktische Übungen"
                            title="praktische Übungen"
                            style={{ maxWidth: "280px", height: "auto" }}
                        />
                    </div>

                    <p className="page-text">
                        In praktischen Übungen zeigen wir Ihnen, wie Sie einen Defibrillator bedienen, was Sie mit einem bewusstlosen Patienten tun müssen und üben an Puppen die Herzdruckmassage.
                    </p>

                    <table className="page-text" style={{ maxWidth: "300px", margin: "20px auto", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr>
                                <td><b>Dauer:</b></td>
                                <td>2 Stunden</td>
                            </tr>
                            <tr>
                                <td><b>Kosten:</b></td>
                                <td>50.- pro Teilnehmer</td>
                            </tr>
                            <tr>
                                <td><b>Termin:</b></td>
                                <td>wird noch bekannt gegeben</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <Footer />
        </main>
    );
};

export default Reanimationstraining;
